<template>
  <div class="container">
    <p class="header"><span class="leftLine"></span>代理商档案</p>
    <div style="padding:20px;background:rgb(249,249,249)">
      <el-row>
        <el-col :span="24">
          <el-form :model="formInline"
                   class="demo-form-inline">
            <el-col :span="8">
              <el-form-item label="代理商姓名/营业执照名称：">
                <el-input v-model="formInline.agentName"
                          placeholder="代理商姓名/营业执照名称"></el-input>
                <el-button type="primary"
                           style="margin-left:20px"
                           @click="current=1;onSubmit()">查询</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-col>
      </el-row>
      <div>
        <div style="background-color: rgba(243, 243, 243, 1);padding-top:20px">
          <el-row style="padding:0 20px">
            <el-col :span="12">
              <p class="text"><i class="el-icon-s-operation"
                                 style="margin-right:10px"></i>代理商列表</p>
            </el-col>
            <el-col :span="12"
                    style="justify-content: flex-end;display:flex">
              <el-upload class="upload-demo"
                         action
                         :show-file-list="false"
                         v-if="show($store.state.menuList.yhgllist,'import')"
                         :http-request="uploadfile">
                <el-button size="small"
                           type="primary">导入</el-button>
              </el-upload>
              <!--<el-button type="primary"
                         style="margin-left:20px"
                         size="mini"
                         v-if="show($store.state.menuList.dlsjsgllist,'export')"
                         @click="exportMethod('https://c.cesc-energy.com/service/user/export','代理商结算.xlsx')">导出数据</el-button>-->
              <el-button type="primary"
                         style="margin-left:20px"
                         size="mini"
                         v-if="show($store.state.menuList.yhgllist,'exportT')"
                         @click="exportMethod('https://c.cesc-energy.com/service/user/export/template','用户列表.xlsx')">导出模板</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-row style="margin-top:20px">
              <div style="overflow:auto">
                <el-table border
                          ref="multipleTable"
                          :data="tableData"
                          tooltip-effect="dark"
                          @selection-change="handleSelectionChange">
                  <el-table-column type="selection">
                  </el-table-column>
                  <el-table-column prop="registDate"
                                   label="登记日期">
                  </el-table-column>
                  <el-table-column prop="provinceName"
                                   label="所在省份">
                  </el-table-column>
                  <el-table-column prop="agentName"
                                   label="姓名/营业执照名称">
                  </el-table-column>
                  <el-table-column prop="contractNumber"
                                   label="代理合同编号">
                  </el-table-column>
                  <el-table-column prop="contractRate"
                                   label="代理合同分成比例">
                  </el-table-column>
                  <el-table-column prop="agentCard"
                                   label="身份证号/营业执照号码">
                  </el-table-column>
                  <el-table-column prop="ourCompanyName"
                                   label="我方公司名称">
                  </el-table-column>
                  <el-table-column prop="superiorAgentName"
                                   label="上级代理商">
                  </el-table-column>
                  <el-table-column prop="saleName"
                                   label="销售负责人">
                  </el-table-column>
                  <el-table-column prop="phoneNumber"
                                   label="代理商手机号码">
                  </el-table-column>
                  <el-table-column prop="address"
                                   label="操作"
                                   show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-button @click="detail(scope.row)"
                                 v-if="show('see')"
                                 type="text"
                                 size="small">查看</el-button>
                      <el-button @click="update(scope.row.agentInfoId)"
                                 type="text"
                                 v-if="show('edit')"
                                 size="small">编辑</el-button>
                      <el-button type="text"
                                 size="small"
                                 v-if="show('delete')"
                                 @click="deleteTable(scope.$index, tableData,scope.row.agentInfoId)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div style="margin-top: 20px;padding:20px">
                <div class="pagination">
                  <el-pagination @current-change="handleCurrentChange"
                                 :current-page="current"
                                 :page-size="10"
                                 background
                                 layout="total, prev, pager, next, jumper"
                                 :total="total">
                  </el-pagination>
                </div>
              </div>
            </el-row>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import {  getmenusubmenu, getAgentPage, getAgent, putAgent, deleteAgent, postAgentFile } from '../../API'
    import { show } from '../../util/show'
    import exportMethod from '../../util/util'
    export default {
        data () {
            return {
                pickerOptions: {
                    disabledDate(time) {
                        //return time.getTime() < Date.now() - 8.64e7;//设置选择今天以及今天之后的日
                        return time.getTime() > Date.now(); //设置选择今天以及今天以前的日期
                    },
                },
                formInline: {},
                checked: false,
                total: 0,
                current: 1,
                tableData: [],
                value: '1',
                multipleSelection: [],
                menuList: []
            }
        },
        created () {
            getAgentPage().then(res => {
                if (res.code === 0) {
                    this.total = res.data.total;
                    this.current = res.data.current;
                    this.tableData = res.data.records
                }
            })
            getmenusubmenu(localStorage.getItem('parentId')).then(res => {
                if (res.code === 0) {
                    this.menuList = res.data
                }
            })
        },
        watch: {
            "$store.state.parantId.parantId" (newval, olval) {
                getmenusubmenu(newval).then(res => {
                    if (res.code === 0) {
                        this.$store.commit('menuList/COMMIT_DATA', { name: 'yhgllist', data: res.data })
                    }
                })
            },
        },
        methods: {
            show,
            exportMethod,
            uploadfile (item) {
                let fileObj = item.file
                let name = fileObj.name;
                if (!/\.(xlsx|xls|XLSX|XLS)$/.test(name)) {
                    this.$notify.error({
                        title: "错误",
                        message: "上传文件只能为excel文件，且为xlsx,xls格式",
                    });
                    return false;
                }
                const form = new FormData()// FormData 对象
                form.append('file', fileObj)// 文件对象  'upload'是后台接收的参数名
                postAgentFile(form).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: '导入成功',
                            type: 'success'
                        });
                    }
                })
            },
            // show (k) {
            //     for (let i = 0; i < this.menuList.length; i++) {
            //         if (k == this.menuList[i].permission) {
            //             return true
            //         }
            //     }
            // },
            deleteTable (index, rows, id) {
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    rows.splice(index, 1);
                    deleteAgent(id).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            getAgentPage().then(res => {
                                if (res.code === 0) {
                                    this.total = res.data.total;
                                    this.current = res.data.current;
                                    this.tableData = res.data.records
                                }
                            })
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            detail (row) {
                this.$router.push({ path: '/agent/detail'})
                console.log("aa:" + row.agentInfoId)
                localStorage.setItem('agentInfoId', row.agentInfoId)
            },
            update (id) {
                this.$router.push({ path: '/agent/update', query: { text: '修改代理商档案', } })
                localStorage.setItem("agentInfoId", id)
            },
            handleSelectionChange (val) {
                this.multipleSelection = val;
            },
            handleCurrentChange (val) {
                this.current = val
                this.onSubmit()
            },
            toggleAllSelection () {
                this.$refs.multipleTable.toggleAllSelection()
            },
            onSubmit () {
                let params = this.formInline
                params.current = this.current
                getAgentPage(params).then(res => {
                    if (res.code === 0) {
                        this.total = res.data.total;
                        this.current = res.data.current;
                        this.tableData = res.data.records
                    }
                })
            }
        }
    }
</script>
<style lang='less' scoped>
  .header {
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
  }
  .container {
    border: none;
    background-color: rgba(236, 240, 245, 1);
    padding: 0 0;
  }
  .leftLine {
    border-left: 5px solid rgba(52, 152, 219, 1);
    padding-right: 10px;
  }
  .el-main {
    background-color: rgba(249, 249, 249, 1);
    padding: 0;
  }
  /deep/ .el-breadcrumb__item {
    float: none;
  }
  .el-breadcrumb {
    height: 50px;
    font-size: 16px;
    line-height: 50px;
    color: #999;
    background-color: rgba(236, 240, 245, 1);
    margin-left: 20px;
  }
  .header {
    font-weight: 700;
    font-style: normal;
    color: #5e5e5e;
  }
  /deep/.el-input {
    width: 217px;
  }
  /deep/ .el-table {
    max-width: 200%;
  }
  .ax_default {
    font-family: "ArialMT", "Arial";
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    border-bottom: 1px solid#333333;
    text-align: center;
    line-height: normal;
  }
  .line {
    height: 1px;
  }
  .pagination {
    float: right;
    /deep/ .el-pagination.is-background .btn-prev:disabled {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .btn-prev {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .btn-next:disabled {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .btn-next {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .el-pager li {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #409eff;
    }
    /deep/ .el-input {
      width: 50px;
    }
  }
</style>
